export const CLASSIFIED_CREATING = 'CLASSIFIED_CREATING'
export const CLASSIFIED_CREATE_SUCCESS = 'CLASSIFIED_CREATE_SUCCESS'
export const CLASSIFIED_CREATE_ERROR = 'CLASSIFIED_CREATE_ERROR'
export const CLEAR_CREATE_CLASSIFIED_NOTIFICATION = 'CLEAR_CREATE_CLASSIFIED_NOTIFICATION'